export default {
  staff: {
    contactAdministrator: 'Bitte kontaktieren Sie Ihren Administrator.',
    defaultContinue: 'Bitte klicken Sie auf die untere Schaltfläche, um mit diesem Standard fortzufahren.',
    memberPin: 'PIN des Teammitglieds',
    errorInactive: 'Inaktives Teammitglied',
    errorInvalidPasscode: 'Ungültiger Passcode',
    errorInvalidPin: 'Ungültige PIN',
    hiName: 'Hallo {n}!',
    passcode: 'Passcode',
    passcodePrompt: 'Bitte geben Sie den Einstellungs Passcode ein',
    pin: 'Geben Sie Ihre PIN ein',
    surveyContinue: 'Bitte klicken Sie auf die untere Schaltfläche, um mit dieser Umfrage fortzufahren.',
    surveysDisabled: 'Alle Umfragen wurden deaktiviert.',
    surveySelect: 'Wählen Sie eine andere Umfrage aus',
    surveySelected: 'Ausgewählte Umfrage',
    startSurvey: 'Umfrage starten'
  }
};